export class User {

    public relations = ['therapist'];

    public names = {
        therapist_id: function (data) {
            // return data.address && data.address.offname;
        },
    }
}
